import type { NotificationResponseSourceSourceUserAllOfTwoAuth } from './notificationResponseSourceSourceUserAllOfTwoAuth';

export type NotificationResponseSourceSourceUserAllOfTwo = {
  /** 계정 활성화 상태 */
  active?: boolean;
  /** 인증 컨텍스트 정보 */
  auth?: NotificationResponseSourceSourceUserAllOfTwoAuth;
  /** 이메일 주소 */
  email?: string;
  /** 팔로워 수 */
  followerCount?: number;
  /** 팔로잉 수 */
  followingCount?: number;
  /** 마지막 로그인 시간 */
  lastLogin?: string;
  /** 사용자 역할 */
  role?: string;
};
